module.exports = __webpack_public_path__ + "img/vehicle-options-white-ford.f7b5d02a.png";